module.exports = __webpack_public_path__ + "static/media/reserve-bike.80e2ec3e.png";